import { FC } from "react";
import { ChangelogHeader } from "./ChangelogHeader";
import { ChangelogForm } from "./ChangelogForm";
import { ChangelogList } from "./ChangelogList";
import { ChangelogConfirmationModal } from "./ChangelogConfirmationModal";
import { ChangelogExists } from "./ChangelogExists";
import { LoadingIndicator } from "../../components/LoadingIndicator";
import { useChangelog } from "./Changelog.hook";
import "./style.css";

export const Changelog: FC = () => {
  const {
    version,
    control,
    changelogRecords,
    isLoading,
    isUpdating,
    isVersionMissingReleaseNotes,
    isChangelogConfirmationModalOpen,
    isChangelogSubmitButtonDisabled,
    onSubmitChangelog,
    onDeleteChangelogRecordClick,
    onAddChangelogRecordClick,
    onClearChangelogRecordFormClick,
    onSwitchChangelogConfirmationModalClick,
  } = useChangelog();

  if (isLoading) {
    return <LoadingIndicator isLoading={isLoading} fullPage />;
  }

  if (!isVersionMissingReleaseNotes) {
    return <ChangelogExists version={version} />;
  }

  return (
    <>
      <ChangelogHeader
        version={version}
        isChangelogSubmitButtonDisabled={isChangelogSubmitButtonDisabled}
        onSubmitChangelogClick={onSwitchChangelogConfirmationModalClick}
      />
      <div className="changelog-records-section">
        <ChangelogForm
          control={control}
          onAddChangelogRecordClick={onAddChangelogRecordClick}
          onClearChangelogRecordFormClick={onClearChangelogRecordFormClick}
        />
        <ChangelogList
          changelogRecords={changelogRecords}
          onDeleteChangelogRecordClick={onDeleteChangelogRecordClick}
        />
      </div>
      <ChangelogConfirmationModal
        isOpen={isChangelogConfirmationModalOpen}
        isUpdating={isUpdating}
        version={version}
        changelogRecordsAmount={changelogRecords.length}
        onConfirm={onSubmitChangelog}
        onClose={onSwitchChangelogConfirmationModalClick}
      />
    </>
  );
};
